import debug from 'debug'
import { get, set } from 'lodash'

const logger = debug('~/src/formcore/services/queryset-configurations')

export function QuerysetConfiguration(source, namespace, separator = '_') {
  const separatorPattern = new RegExp(`${separator}`, 'g')
  return source
    .replace('?', '')
    .split('&')
    .map((keyvalue) => {
      const [key, value] = keyvalue.split('=')
      return { key, value }
    })
    .filter((item) => item.key.startsWith(namespace))
    .reduce((result, item) => {
      const { key, value: initialvalue } = item
      let value = decodeURIComponent(initialvalue)
      const newKey = key.replace(separatorPattern, '.')
      const existing = get(result, newKey)
      try {
        value = JSON.parse(value)
      } catch (err) {
        logger(`Could not json parse ${value}`)
      }

      if (!existing) {
        return set(result, newKey, value)
      }

      // value exist at path, so
      // we turn it into an array of items
      // or just merge it with more items
      set(
        result,
        newKey,
        !Array.isArray(existing) ? [existing, value] : [...existing, value]
      )
      return result
    }, {})
}
